import React from "react";

import { navLinkDataLayer } from "../../../../../utils/navLinkDataLayer";
import MenuItemLink from "../MenuItemLink";

import styles from "./TrialBtn.module.scss";
import useIsStickyNavStore from "../../../../../sp-state/useIsStickyNavStore";
import { mxpPrimaryCtaClicked } from "../../../../../utils/mixpanelEvents/mixpanelEvents";
import { marketingCtaClicked } from "@utils/segment/marketingCtaClicked";

type TrialBtnLinkType = {
  btnText: string;
  btnPath: string;
  [key: string]: any;
};

const TrialBtnLink: React.FC<TrialBtnLinkType> = ({
  btnPath,
  btnText,
  ...rest
}) => {
  const isSticky = useIsStickyNavStore(state => state.isSticky);

  const handleClick: React.MouseEventHandler = e => {
    navLinkDataLayer({
      path: window.location.host + btnPath,
      btnText: btnText,
    });

    mxpPrimaryCtaClicked(btnPath, btnText);

    marketingCtaClicked({
      text: e.currentTarget.textContent as string,
      url: window.location.pathname,
      target: btnPath,
    });
  };

  return (
    <MenuItemLink
      data-testid="trial-btn-link"
      className={`${styles.btnTrial} ${isSticky && styles.isSticky}`}
      menuItemLabel={btnText}
      path={btnPath}
      onClick={handleClick}
      data-click-type="sign_up_cta"
      data-click-text="Start For Free"
      data-click-location="Navigation"
      {...rest}
    />
  );
};

export default TrialBtnLink;
